<template>
  <div class="f-ml-7 f-pl-1.5">
    <input
      type="radio"
      class="f-form-radio f--ml-7 f--mt-0.5"
      :name="name"
      :id="id"
      :checked="value"
      :value="inputValue"
      v-bind="$attrs"
      @change="$emit('input', $event.target.checked)"
    />
    <label class="f-ml-2" :for="id">
      <slot />
    </label>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "BaseRadio",
  props: {
    id: {
      type: String,
      default: function () {
        return "radio-id-" + this.uid;
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    inputValue: {
      default: true,
    },
    name: {
      type: String,
      default: function () {
        return "radio-name-" + this.uid;
      },
    },
  },
});
</script>
